const eployees = [
  {
    id: 1,
    fname: 'Sushila',
    lname: 'Penjani',
    sex: 'female',
    img: require( '../Images/employees/sage-kirk-485982-unsplash.jpg'),
    eMail: 'sushila.enjani@unitravel.com',
    description: 'ullamcorper sit amet risus nullam eget felis eget nunc lobortis mattis aliquam faucibus purus in massa tempor nec feugiat nisl pretium fusce id velit ut tortor pretium viverra suspendisse potenti nullam ac tortor vitae purus faucibus ornare suspendisse sed nisi lacus sed viverra tellus in hac habitasse platea dictumst vestibulum'
  },
  {
    id: 2,
    fname: 'Caitlin',
    lname: 'Sandra',
    sex: 'female',
    img: require( '../Images/employees/edward-cisneros-415601-unsplash.jpg'),
    eMail: 'caitlin.sandra@unitravel.com',
    description: 'quisque non tellus orci ac auctor augue mauris augue neque gravida in fermentum et sollicitudin ac orci phasellus egestas tellus rutrum tellus pellentesque eu tincidunt tortor aliquam nulla facilisi cras fermentum odio eu feugiat pretium nibh ipsum consequat nisl vel pretium lectus quam id leo in vitae turpis massa sed'
  },{
    id: 3,
    fname: 'Leonty',
    lname: 'Munashe',
    sex: 'male',
    img: require( '../Images/employees/marius-ciocirlan-398931-unsplash.jpg'),
    eMail: 'leonty.munashe@unitravel.com',
    description: 'nunc sed velit dignissim sodales ut eu sem integer vitae justo eget magna fermentum iaculis eu non diam phasellus vestibulum lorem sed risus ultricies tristique nulla aliquet enim tortor at auctor urna nunc id cursus metus aliquam eleifend mi in nulla posuere sollicitudin aliquam ultrices sagittis orci a scelerisque purus'
  },{
    id: 4,
    fname: 'Rohan',
    lname: 'Prakash',
    sex: 'male',
    img: require( '../Images/employees/sandy-millar-1474214-unsplash.jpg'),
    eMail: 'rohan.prakash@unitravel.com',
    description: 'euismod elementum nisi quis eleifend quam adipiscing vitae proin sagittis nisl rhoncus mattis rhoncus urna neque viverra justo nec ultrices dui sapien eget mi proin sed libero enim sed faucibus turpis in eu mi bibendum neque egestas congue quisque egestas diam in arcu cursus euismod quis viverra nibh cras pulvinar'
  },{
    id: 5,
    fname: 'Burkhard',
    lname: 'Sindre',
    sex: 'male',
    img: require( '../Images/employees/norman-toth-177973-unsplash.jpg'),
    eMail: 'burkhard.sindre@unitravel.com',
    description: 'arcu non sodales neque sodales ut etiam sit amet nisl purus in mollis nunc sed id semper risus in hendrerit gravida rutrum quisque non tellus orci ac auctor augue mauris augue neque gravida in fermentum et sollicitudin ac orci phasellus egestas tellus rutrum tellus pellentesque eu tincidunt tortor aliquam nulla'
  }
]

export default eployees